const INITIAL_AVAILABILITY = [
  {
    days: 0,
    timeStart: '0900',
    timeEnd: '2000',
    active: true,
  },
  {
    days: 1,
    timeStart: '0900',
    timeEnd: '2000',
    active: true,
  },
  {
    days: 2,
    timeStart: '0900',
    timeEnd: '2000',
    active: true,
  },
  {
    days: 3,
    timeStart: '0900',
    timeEnd: '2000',
    active: true,
  },
  {
    days: 4,
    timeStart: '0900',
    timeEnd: '2000',
    active: true,
  },
  {
    days: 5,
    timeStart: '0900',
    timeEnd: '2000',
    active: false,
  },
  {
    days: 6,
    timeStart: '0900',
    timeEnd: '2000',
    active: false,
  },
]

const LIMIT_COLOR_STAR = 4.5

const CONNECTED_SINCE = {
  palier1: 60 * 24,
  palier2: 60 * 168,
  palier3: 60 * 730,
}

export { INITIAL_AVAILABILITY, LIMIT_COLOR_STAR, CONNECTED_SINCE }
